"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _Client = _interopRequireDefault(require("./Client"));

/**
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe Inc. and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe Inc.
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Inc.
 */

/**
 * The AccessRequests class handles listing AccessRequests data (i.e. AccessRequests shared with a user) for a specific user.
 */
var AccessRequests = /*#__PURE__*/function () {
  function AccessRequests() {
    (0, _classCallCheck2["default"])(this, AccessRequests);
  }

  (0, _createClass2["default"])(AccessRequests, [{
    key: "get",

    /**
     * Get pending access requests that the user can grant or reject
     * @param {Object} options - (optional) Sorting and filtering options, as listed below
     *
     *        {String} orderBy - (optional, default = '-requesttime') Field to sort on, and direction. E.g. '-requesttime'
     *                           for sorting by ascending request create date. Prefix with "-" for descending.
     *        {String[]} types - (optional) Comma Separated List, types of resource to return. If omitted, all types are returned.
     *        {String} limit - (optional, default = 10, max = 30) maximum number of requests to return.
     *                           for sorting by ascending request create date. Prefix with "-" for descending.
     *        {String} resourceUrn - (optional) if set, api returns access requests on a particular resource.
     * @returns {Promise}
     */
    value: function get() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$orderBy = options.orderBy,
          orderBy = _options$orderBy === void 0 ? '-requesttime' : _options$orderBy,
          _options$types = options.types,
          types = _options$types === void 0 ? [] : _options$types,
          _options$limit = options.limit,
          limit = _options$limit === void 0 ? 10 : _options$limit,
          resourceUrn = options.resourceUrn;
      var suffix = "?orderBy=".concat(encodeURIComponent(orderBy), "&limit=").concat(limit);

      if (types.length > 0) {
        suffix = suffix.concat("&type=".concat(encodeURIComponent(types.join(','))));
      }

      if (resourceUrn) {
        suffix = suffix.concat("&resourceUrn=".concat(encodeURIComponent(resourceUrn)));
      }

      return _Client["default"].instance.fetch({
        type: 'accessrequests.get',
        urlPath: "/accessrequests".concat(suffix),
        returnRaw: true
      });
    }
    /**
     * Get the next page of AccessRequests results, using the URL from AccessRequests.get().
     * @param urlPath {String} URL from AccessRequests.get(), from the _links.next property of the response.
     * @returns {Promise|*|Promise<Response>}
     */

  }, {
    key: "getNextPage",
    value: function getNextPage(urlPath) {
      return _Client["default"].instance.fetch({
        type: 'accessrequests.get',
        urlPath: urlPath,
        returnRaw: true
      });
    }
    /**
     * Request access to a resource
     * {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=collaboration&title=Invitations+Service+V2#InvitationsServiceV2-POST/api/v2/accessrequests-requestaccesstoaresource}
     *
     * @param {Object} options - (required) options, as listed below
     *        {String} resourceUrn - (required) URN of the resource to request access.
     *        {String} templateName - (required) Name of template registered with APO (Adobe Post Office) with the 'cc_collab_' prefix.
     *        {String} locale - (optional, default = 'EN_US') Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code.
     *        {String} targetUrl - (optional, default = '') the url to view the request, typically a web url. The maximum length of the value is 300 characters. 
     *                   If specified, it will be sent in the ANS/email notification as the request's URL. Must be a valid URL. The host of the url must be whitelisted by the service. 
     *        {String} message - (optional, default = '') A custom message for the inviter to add to the invite notification. The maximum length of the value is 300 characters. 
     *                   The following special characters in the message are removed: &, >, <, /, :, \n, \r. The corresponding email param is Param_Custom_Message.
     * @returns {Promise}
     */

  }, {
    key: "request",
    value: function request() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _options$locale = options.locale,
          locale = _options$locale === void 0 ? 'EN_US' : _options$locale,
          message = options.message,
          resourceUrn = options.resourceUrn,
          targetUrl = options.targetUrl,
          templateName = options.templateName;

      if (resourceUrn && resourceUrn !== '' && templateName && templateName !== '') {
        var notification = {
          email: {
            templateName: templateName,
            locale: locale
          },
          parameters: {
            targetUrl: targetUrl,
            message: message
          }
        };
        var body = {
          resourceUrn: resourceUrn,
          notification: notification
        };
        return _Client["default"].instance.fetch({
          type: 'accessrequests.request',
          urlPath: '/accessrequests',
          method: 'POST',
          returnRaw: true,
          body: body
        });
      }

      throw new Error('accessrequests.request failed');
    }
    /**
     * Respond to request access to a resource
     * {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=collaboration&title=Invitations+Service+V2#InvitationsServiceV2-POST/api/v2/accessrequests-requestaccesstoaresource}
     *
     * @param {Object} options - (required) options, as listed below
     *        {String} resourceUrn - (required) URN of the requested resource.
     *        {String} requesterId - (required) userID of the requester.
     *        {String} role - (required when action is 'grant').
     *        {String} action - (required) Either 'grant' or 'reject'.
     *        {String} templateName - (required) Name of template registered with APO (Adobe Post Office) with the 'cc_collab_' prefix.
     *        {String} locale - (optional, default = 'EN_US') Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code.
     *        {String} targetUrl - (optional, default = '') the url to view the request, typically a web url. The maximum length of the value is 300 characters. 
     *                   If specified, it will be sent in the ANS/email notification as the request's URL. Must be a valid URL. The host of the url must be whitelisted by the service. 
     *        {String} message - (optional, default = '') A custom message for the inviter to add to the invite notification. The maximum length of the value is 300 characters. 
     *                   The following special characters in the message are removed: &, >, <, /, :, \n, \r. The corresponding email param is Param_Custom_Message.
     * @returns {Promise}
     */

  }, {
    key: "respond",
    value: function respond() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var action = options.action,
          _options$locale2 = options.locale,
          locale = _options$locale2 === void 0 ? 'EN_US' : _options$locale2,
          message = options.message,
          requesterId = options.requesterId,
          targetUrl = options.targetUrl,
          resourceUrn = options.resourceUrn,
          role = options.role,
          templateName = options.templateName;

      if (resourceUrn && resourceUrn !== '' && requesterId && requesterId !== '' && action && action !== '' && templateName && templateName !== '') {
        if (action === 'grant' && role && role !== '' || action === 'reject') {
          var notification = {
            email: {
              templateName: templateName,
              locale: locale
            },
            parameters: {
              targetUrl: targetUrl,
              message: message
            }
          };
          var body = {
            action: action,
            role: role,
            requesterId: requesterId,
            resourceUrn: resourceUrn,
            notification: notification
          };
          return _Client["default"].instance.fetch({
            type: 'accessrequests.respond',
            urlPath: '/accessrequests/ops',
            method: 'POST',
            returnRaw: true,
            body: body
          });
        }
      }

      throw new Error('accessrequests.respond failed');
    }
    /**
     * Grant request access to a resource
     * {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=collaboration&title=Invitations+Service+V2#InvitationsServiceV2-POST/api/v2/accessrequests-requestaccesstoaresource}
     *
     * @param {Object} options - (required) options, as listed below
     *        {String} resourceUrn - (required) URN of the requested resource.
     *        {String} requesterId - (required) userID of the requester.
     *        {String} role - (required).
     *        {String} templateName - (required) Name of template registered with APO (Adobe Post Office) with the 'cc_collab_' prefix.
     *        {String} locale - (optional, default = 'EN_US') Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code.
     *        {String} requestViewUrl - (optional, default = '') the url to view the request, typically a web url. The maximum length of the value is 300 characters. 
     *                   If specified, it will be sent in the ANS/email notification as the request's URL. Must be a valid URL. The host of the url must be whitelisted by the service. 
     *        {String} message - (optional, default = '') A custom message for the inviter to add to the invite notification. The maximum length of the value is 300 characters. 
     *                   The following special characters in the message are removed: &, >, <, /, :, \n, \r. The corresponding email param is Param_Custom_Message.
     * @returns {Promise}
     */

  }, {
    key: "grant",
    value: function grant() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.respond(Object.assign({}, options, {
        action: 'grant'
      }));
    }
    /**
     * Reject request access to a resource
     * {@link https://wiki.corp.adobe.com/pages/viewpage.action?spaceKey=collaboration&title=Invitations+Service+V2#InvitationsServiceV2-POST/api/v2/accessrequests-requestaccesstoaresource}
     *
     * @param {Object} options - (required) options, as listed below
     *        {String} resourceUrn - (required) URN of the requested resource.
     *        {String} requesterId - (required) userID of the requester.
     *        {String} role - (required).
     *        {String} templateName - (required) Name of template registered with APO (Adobe Post Office) with the 'cc_collab_' prefix.
     *        {String} locale - (optional, default = 'EN_US') Specifies the locale to be used to select the appropriate template. It is provided in the form of a language code and country code.
     *        {String} requestViewUrl - (optional, default = '') the url to view the request, typically a web url. The maximum length of the value is 300 characters. 
     *                   If specified, it will be sent in the ANS/email notification as the request's URL. Must be a valid URL. The host of the url must be whitelisted by the service. 
     *        {String} message - (optional, default = '') A custom message for the inviter to add to the invite notification. The maximum length of the value is 300 characters. 
     *                   The following special characters in the message are removed: &, >, <, /, :, \n, \r. The corresponding email param is Param_Custom_Message.
     * @returns {Promise}
     */

  }, {
    key: "reject",
    value: function reject() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.respond(Object.assign({}, options, {
        action: 'reject'
      }));
    }
  }]);
  return AccessRequests;
}();
/**
 * Exports the AccessRequests class.
 */


var _default = AccessRequests;
exports["default"] = _default;